export default "__VITE_ASSET__DnVBiKKE__"